import { Form } from '@loophealth/loop-ui-web-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectUserAttributes } from '../../../pages/LoginContainer/redux/slices/UserSlice/selectors';
import {
    EUserAttributeFieldInputType,
    IUserAttributeField,
    IUserAttributeFieldValue
} from '../../../pages/LoginContainer/redux/slices/UserSlice/types';
import { StyledUserAttributeFieldsContainer } from './styles';
import { capitalizeFirstLetter } from '../../../../utils/common';

interface IUserAttributesFieldsProps {
    values: Record<string, IUserAttributeFieldValue>;
    setValues: React.Dispatch<React.SetStateAction<Record<string, IUserAttributeFieldValue>>>;
}

const UserAttributesFields: React.FC<IUserAttributesFieldsProps> = ({ values, setValues }) => {
    const userAttributesData = useSelector(selectUserAttributes);
    const attributes = userAttributesData.data?.attributes ?? [];

    const handleValueChange = (attributeName: string, value: IUserAttributeFieldValue) => {
        setValues((prevValues) => ({
            ...prevValues,
            [attributeName]: value
        }));
    };

    const getInputField = (attr: IUserAttributeField, value: IUserAttributeFieldValue): React.ReactNode => {
        switch (attr.inputType) {
        case EUserAttributeFieldInputType.DROPDOWN:
            return (
                <Form.Dropdown
                    listItems={attr.allowedValues?.map((s) => ({ name: capitalizeFirstLetter(s), value: s })) ?? []}
                    selectedItem={(value as string) ?? ''}
                    placeholder="Select from options"
                    onClick={(item) => handleValueChange(attr.attributeName, item)}
                />
            );
        case EUserAttributeFieldInputType.DATE:
            return (
                <Form.DatePicker
                    value={value as Date}
                    placeholder="Select date"
                    onChange={(date) => handleValueChange(attr.attributeName, date)}
                />
            );
        case EUserAttributeFieldInputType.TEXTFIELD:
            return (
                <Form.Input
                    value={(value as string) ?? ''}
                    placeholder="Type here"
                    onChange={(e) => {
                        handleValueChange(attr.attributeName, e.target.value);
                    }}
                    name={attr.attributeName}
                    type={attr.type === 'string' ? 'text' : 'number'}
                    data-testid={`user-attribute-field-${attr.attributeName}`}
                />
            );
        }
    };

    return (
        <StyledUserAttributeFieldsContainer>
            {attributes.map((attr) => (
                <Form.FormField key={attr.attributeName} id={attr.attributeName} label={attr.displayName} required>
                    {getInputField(attr, values[attr.attributeName])}
                </Form.FormField>
            ))}
        </StyledUserAttributeFieldsContainer>
    );
};

export default UserAttributesFields;
